import { client } from 'src/enviroment/api/axios'
import { useMutation, useQuery } from '@tanstack/react-query'
import { handleApiError } from 'src/enviroment/api/errorHandler'
import { Mutation, Query } from '../index'
import { OauthInteraction, OauthInteractionRedirect } from 'src/types/oauth'

export const oauthRouterKeys = {
  interaction: (uid: string) => `oauth.interaction.${uid}`,
} as const

// The backend checks its interaction cookie, proving this browser started the authorization.
const withInteractionCookie = { withCredentials: true }

const finishInteraction = async (uid: string, action: 'consent' | 'abort') =>
  (await client.post<OauthInteractionRedirect>(`/oauth/interaction/${uid}/${action}`, null, withInteractionCookie)).data

export const oauthRouter = {
  interaction: {
    useQuery: (uid: string, opts?: Query<OauthInteraction>) => {
      return useQuery<OauthInteraction>({
        queryKey: [oauthRouterKeys.interaction(uid)],
        queryFn: async () => {
          return (await client.get<OauthInteraction>(`/oauth/interaction/${uid}`, withInteractionCookie)).data
        },
        retry: false,
        // One-shot: after Allow/Deny the interaction is gone, so a refetch would flip the page to expired.
        staleTime: Infinity,
        ...opts,
      })
    },
  },
  consent: {
    useMutation: (opts?: Mutation<string, OauthInteractionRedirect>) => {
      return useMutation({
        mutationFn: (uid: string) => finishInteraction(uid, 'consent'),
        onError: handleApiError,
        ...opts,
      })
    },
  },
  abort: {
    useMutation: (opts?: Mutation<string, OauthInteractionRedirect>) => {
      return useMutation({
        mutationFn: (uid: string) => finishInteraction(uid, 'abort'),
        onError: handleApiError,
        ...opts,
      })
    },
  },
}
